import { Pipe, PipeTransform } from '@angular/core';
import { CCMCUtils } from '../../@ccmc/utils';

@Pipe({name: 'filter'})
export class FilterPipe implements PipeTransform {
    transform(mainArr: any[], searchText: string, property: string): any {
        return CCMCUtils.filterArrayByString(mainArr, searchText);
    }
}
